"use client"

import { useState } from "react"
import styles from "./style.module.scss"
import logo from "../../assets/logo.png"
import { AiOutlineEye, AiOutlineEyeInvisible, AiOutlineLock, AiOutlineMail } from "react-icons/ai"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"
import { useAuth } from "../../contexts/AuthContext"

const Login = () => {
  const { login } = useAuth()
  const navigate = useNavigate()
  const [showPassword, setShowPassword] = useState(false)
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState({ email: "", password: "" })
  const [touched, setTouched] = useState({ email: false, password: false })

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  const validateField = (name, value) => {
    let error = ""

    if (name === "email") {
      if (!value) {
        error = "E-mail é obrigatório"
      } else if (!/\S+@\S+\.\S+/.test(value)) {
        error = "E-mail inválido"
      }
    }

    if (name === "password") {
      if (!value) {
        error = "Senha é obrigatória"
      } else if (value.length < 6) {
        error = "Senha deve ter pelo menos 6 caracteres"
      }
    }

    return error
  }

  const handleEmailChange = (e) => {
    const value = e.target.value
    setEmail(value)

    if (touched.email) {
      setErrors((prev) => ({
        ...prev,
        email: validateField("email", value),
      }))
    }
  }

  const handlePasswordChange = (e) => {
    const value = e.target.value
    setPassword(value)

    if (touched.password) {
      setErrors((prev) => ({
        ...prev,
        password: validateField("password", value),
      }))
    }
  }

  const handleBlur = (field) => {
    setTouched((prev) => ({ ...prev, [field]: true }))

    const value = field === "email" ? email : password
    setErrors((prev) => ({
      ...prev,
      [field]: validateField(field, value),
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    // Validate all fields
    const emailError = validateField("email", email)
    const passwordError = validateField("password", password)

    setErrors({ email: emailError, password: passwordError })
    setTouched({ email: true, password: true })

    if (emailError || passwordError) {
      return
    }

    setLoading(true)

    try {
      const logged = await login(email, password)
      console.log('logged', logged)

      if (logged) {
        window.location.href = '/dashboard';

        toast.success("Login realizado com sucesso!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "dark",
        })

        navigate("/dashboard")
        
      } else {
        toast.error("Credenciais inválidas", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "dark",
        })
      }
    } catch (error) {
      console.error("Erro ao fazer login:", error)
      toast.error("Erro interno. Tente novamente.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "dark",
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.backgroundDecoration}>
        <div className={styles.circle1}></div>
        <div className={styles.circle2}></div>
        <div className={styles.circle3}></div>
      </div>

      <div className={styles.loginBox}>
        <div className={styles.logoContainer}>
          <img src={logo || "/placeholder.svg"} alt="Logo" className={styles.logo} />
        </div>

        <div className={styles.welcomeText}>
          <h1>Bem-vindo de volta</h1>
          <p>Entre com suas credenciais para continuar</p>
        </div>

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.inputGroup}>
            <label htmlFor="email" className={styles.label}>
              E-mail
            </label>
            <div
              className={`${styles.inputContainer} ${errors.email ? styles.error : ""} ${email ? styles.filled : ""}`}
            >
              <input
                type="email"
                id="email"
                value={email}
                onChange={handleEmailChange}
                onBlur={() => handleBlur("email")}
                required
                className={styles.input}
                placeholder="seu@email.com"
                disabled={loading}
              />
              <span className={styles.inputIcon}>
                <AiOutlineMail />
              </span>
            </div>
            {errors.email && <span className={styles.errorMessage}>{errors.email}</span>}
          </div>

          <div className={styles.inputGroup}>
            <label htmlFor="password" className={styles.label}>
              Senha
            </label>
            <div
              className={`${styles.inputContainer} ${errors.password ? styles.error : ""} ${password ? styles.filled : ""}`}
            >
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                value={password}
                onChange={handlePasswordChange}
                onBlur={() => handleBlur("password")}
                required
                className={styles.input}
                placeholder="••••••••"
                disabled={loading}
              />
              <span className={styles.inputIcon}>
                <AiOutlineLock />
              </span>
              <button
                type="button"
                onClick={togglePasswordVisibility}
                className={styles.toggleButton}
                disabled={loading}
              >
                {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
              </button>
            </div>
            {errors.password && <span className={styles.errorMessage}>{errors.password}</span>}
          </div>

          <button type="submit" className={`${styles.loginButton} ${loading ? styles.loading : ""}`} disabled={loading}>
            {loading ? (
              <>
                <span className={styles.spinner}></span>
                Entrando...
              </>
            ) : (
              "Entrar"
            )}
          </button>
        </form>

      </div>
    </div>
  )
}

export default Login
